import axios from "axios";
export const apiUrl = "https://api-kine.coreplxs.com/api"

export default axios.create({
 baseURL: apiUrl
  // baseURL: "https://dev.api.noul.net/api"
  // baseURL: "http://2b4555709a9a.ngrok.io/api",
});

